var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart-wrapper solarchart"},[_c('h2',{staticClass:"chart-header"},[_vm._v("Monday")]),_c('div',{staticClass:"chart"})])}]

export { render, staticRenderFns }